import jsPDF from 'jspdf';
import '../../fonts/OpenSans-Regular-normal';
import '../../fonts/OpenSans-SemiBold-bold';
import template_for_pdf from '../../img/template_for_pdf.jpg';

// Путь к изображениям
// const PATH_IMG = process.env.REACT_APP_IMG_URL;
// const PATH_IMG = 'http://localhost:3000';

/**
 * Загружает изображение и возвращает Data URL
 */
const loadImage = (url) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        // img.crossOrigin = 'Anonymous';
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = url;
    });
};

/**
 * Генерирует PDF документ с расчётом
 * @param {Object} allFields - текущие данные формы
 * @param {number} result - итоговая сумма
 * @param {Object} allShapes - данные о всех формах столдешниц
 */
export const generatePDF = async (allFields, allShapes, result) => {
    try {
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4',
        });

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // 1. Добавляем фоновый шаблон (шапка + футер + водяной знак)
        // const templateImg = await loadImage(TEMPLATE_IMAGE);
        pdf.addImage(template_for_pdf, 'JPEG', 0, 0, pageWidth, pageHeight);

        // 2. Добавляем изображение формы столешницы
        const currentShape = allShapes.filter((curr) => curr.shape === allFields.shape);
        const shapeImg = await loadImage('/static/img' + currentShape[0].view);
        // Позиция изображения (подстройте под ваш шаблон)
        pdf.addImage(shapeImg, 'JPEG', 50, 35, 150, 100);

        // 3. Настраиваем шрифт для текста
        pdf.setFont('OpenSans-Regular', 'normal');
        pdf.setFontSize(14);
        pdf.setTextColor(0, 0, 0);

        // Начальная позиция для списка (подстройте под ваш шаблон)
        let startY = 140;
        const lineHeight = 10;
        const leftMargin = 20;

        // 4. Формируем список параметров
        const items = [
            { label: '1. Производитель:', value: allFields.stone.producer.toUpperCase() },
            { label: '2. Цвет выбранного камня:', value: allFields.stone.color },
            { label: '3. Размер A, мм:', value: allFields.dimentions.length_a },
            { label: '4. Размер B, мм:', value: allFields.dimentions.length_b },
            { label: '5. Размер C, мм:', value: allFields.dimentions.length_c || '-' },
            { label: '6. Размер D, мм:', value: allFields.dimentions.length_d || '-' },
            { label: '7. Тип фаски:', value: allFields.chamfer },
            { label: '8. Монтаж мойки под столешницу:', value: allFields.additional.sink ? 'ДА' : 'НЕТ' },
            { label: '9. Монтаж в пределах Одессы:', value: allFields.additional.montage ? 'ДА' : 'НЕТ' },
            { label: '10. Доставка в пределах Одессы:', value: allFields.additional.delivery ? 'ДА' : 'НЕТ' },
        ];

        // 5. Выводим список
        items.forEach((item, index) => {
            const y = startY + index * lineHeight;
            pdf.text(item.label, leftMargin, y);
            pdf.text(String(item.value), leftMargin + 85, y);
        });

        // 6. Добавляем ИТОГО
        const totalY = startY + items.length * lineHeight + 5;
        pdf.setFont('OpenSans-SemiBold', 'bold');
        pdf.setFontSize(14);
        pdf.text('ИТОГО:', leftMargin, totalY);
        pdf.text(`${result.toFixed(2)} дол.`, leftMargin + 85, totalY);

        // 7. Добавляем дату расчёта
        pdf.setFont('OpenSans-Regular', 'normal');
        pdf.setFontSize(10);
        pdf.setTextColor(100, 100, 100);
        const currentDate = new Date().toLocaleDateString('ru-RU', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        pdf.text(`Дата: ${currentDate}`, leftMargin - 10, totalY + 26);

        return pdf;
    } catch (error) {
        console.error('Ошибка генерации PDF:', error);
        throw new Error('Не удалось создать PDF документ');
    }
};

/**
 * Скачать PDF файл
 */
export const downloadPDF = async (allFields, result, producerData) => {
    const pdf = await generatePDF(allFields, result, producerData);
    const fileName = `Расчет_столешницы_Интеркам_${new Date().toISOString().split('T')[0]}.pdf`;
    pdf.save(fileName);
};

/**
 * Печать PDF
 */
export const printPDF = async (allFields, result, producerData) => {
    const pdf = await generatePDF(allFields, result, producerData);

    // Открываем PDF в новом окне для печати
    const pdfBlob = pdf.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const printWindow = window.open(pdfUrl);
    printWindow.addEventListener('load', () => {
        printWindow.print();
    });
};
